import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";



class DRSReportDetail extends PureComponent {
  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData1: [],
      date: currDate,
      total_value:""
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("DRSData");
    var printDetails = JSON.parse(printDetail_data);
    /* console.log(printDetail_data);*/
    var sub_total = 0;
    var total_val;
    for(var i= 0; i< printDetails.length; i++){
      total_val = sub_total + printDetails[i].box_id_count;
      sub_total = total_val
    }
    this.setState({
      showPrintData1: printDetails,
      total_value: total_val
    })



    setTimeout(this.prinData, 1100);

  }

  prinData() {
    /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
    window.print();

    /*}*/
  }

  onLogin() {
    axios
      .post(
        "http://3.215.84.36:8088/auth/oauth2/login",

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "",
          },
        }
      )
      .then((response) => {
        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    
   
    
    return (
      <div className="print_table">
        <Table style={{borderWidth: 0, marginBottom: 0, width: '90%', margin: 'auto', marginTop: 30}}
        >
            <thead
              style={{ background: "#ccc" }}
            >
              <tr style={{ marginTop: 20, background: "#fff" }}>
        
                <th style={{textAlign: 'center', borderWidth: 0}} colspan="12"><h4 style={{margin: 0, fontWeight: 'bold'}}>Lynk Logistics Ltd</h4><br/><h5 style={{marginTop: -13, fontWeight: 'bold'}}>DRS BOX ID Print Out</h5></th>
               </tr>
                <tr style={{ marginTop: 2, background: "#fff" }}>
        
                <th style={{textAlign: 'center', borderWidth: 0}} colspan="12"></th>
               </tr>
            </thead>
        </Table> 

        <div style={{ width: "90%", margin: 'auto' }}>
          <table style={{width: '100%', padding: 15, borderWidth: 0}}
                    responsive
                    
                  >
                      <tr>
                        <td style={{borderWidth: 0}} colspan = "6"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Trip id:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].trip_id} </span>}{" "}
                          </h5>
                        </td>

                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "5"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Bill count:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1.length} </span>}{" "}
                          </h5>
                        </td>
                      </tr>

                      <tr>
                        <td style={{borderWidth: 0}} colspan = "6"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Trip Execution date:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].trip_exec_date} </span>}{" "}
                          </h5>
                        </td>

                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "5"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Bill value:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].bill_value} </span>}{" "}
                          </h5>
                        </td>
                      </tr>

                      <tr>
                       

                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "6"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Cashier Name:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].cashier_name} </span>}{" "}
                          </h5>
                        </td>

                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "5"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Seq/Kms/time(hrs):{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].seq} </span>}{" "}
                          </h5>
                        </td>
                      </tr>

                       <tr>
                        <td style={{borderWidth: 0}} colspan = "9"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Van Name:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].van_name} </span>}{" "}
                          </h5>
                        </td>

                      
                      </tr>

                      
                    </table>

                     <table style={{width: '100%', padding: 15, borderWidth: 0, marginTop: 20}}
                    responsive
                    
                  >
                    <thead
                      className="thead_align"
                      style={{ background: "#ccc" }}
                    >
                   <tr className="border-thead border_head border_thead drs_thead" style={{ marginTop: 20 }}>
                         <th style={{ marginTop: 20 }}>Sr No.</th> 
                        <th style={{ marginTop: 20 }}>Bill No </th>
                        <th style={{ marginTop: 20 }}> PARTY </th>
                         <th style={{ marginTop: 20 }}> Van Name </th>
                        <th style={{ marginTop: 20 }}> BOX ID Count </th>
                        
                        

                        <th style={{ marginTop: 20 }}> Box Ids </th>

                        </tr>

                    </thead>

                     <tbody>
                      {this.state.showPrintData1.length > 0 &&
                        this.state.showPrintData1.map((item, index) => (
                          <tr className="border-thead border_thead drs_row">
                            <td>{index+1}</td>
                            <td>{item.bill_no}</td>
                            <td>{item.party_name}</td>
                             <td>{item.van_name}</td>
                            <td>{item.box_id_count}</td>
                            <td id="drs_column" style={{fontSize: 13}}>{item.box_ids}</td>
                          </tr>
                        ))}
                </tbody>
                <tfoot>
                <td colspan="3"></td>
                <td>Total Box Id Count: {this.state.total_value}</td>
                {this.state.showPrintData1.length>0 &&
                  <td>Total: {this.state.showPrintData1[0].bill_value}</td>
                }
                {this.state.showPrintData1.length == 0 &&
                  <td></td>
                }
                

                </tfoot>

                    </table>
        </div> 

       
       
      </div>
    );
  }
}

export default DRSReportDetail;
